<template lang="pug">
v-stepper(v-model="currentStep")
  //- p.subheading.mx-4.my-1 {{ form }}
  v-stepper-header
    div(v-for="(header, index) in stepperHeaders", :class="{ layout: index }")
      v-divider(v-if="index > 0")
      v-stepper-step(
        :step="index + 1",
        :complete="edit ? true : currentStep > index + 1",
        :editable="edit ? true : currentStep > index + 1",
        :edit-icon="edit ? 'edit' : 'check'"
      ) {{ header }}

  v-dialog(v-model='dialogInactiveApprover' persistent='' max-width='370')
    v-card
      v-card-title(style="display: flex; justify-content: center; font-size:40px;")
        v-icon.mr-2(
          style="margin-top:1rem; font-size:40px;"
          title="edit",
          color="red",
          @click="onEdit(item.id, item.user_id)"
        )
          | error
      v-card-text(style="font-size:16px; text-align: center;margin-top:1rem")
        | {{ errorActiveUserMsg}}
      v-card-actions(style="justify-content: center;")
        v-btn(style="background: #1976D2; color: white; margin-bottom:1rem; width:80%" text='' @click='dialogInactiveApprover = false')
          | OK


  v-stepper-items
    v-stepper-content(step="1")
      v-layout(row, wrap)
        v-flex(xs5, sm12)
          v-flex(xs12, sm12, d-flex)
          v-row
            v-col.mt-6(cols="2")
              v-subheader.mt-2(color="black")
                span.red--text *
                span(style="font-size: 15px; font-weight: 600") Business Unit
            v-col.mt-2(cols="9")
              v-autocomplete.mt-6(
                v-if="this.$store.state.dataUsers.role == 'super_user'",
                label="Select a business unit",
                id="imSelectBU",
                :disabled="edit == true && dataUsers.id !== dataEditRequest.creator.id ? true : false",
                :items="business_units",
                v-model="bu",
                no-data-text="No data available",
                chips,
                color="blue-grey lighten-2",
                item-text="bu_name",
                item-value="id",
                return-object,
                clearable
              )
                template(
                  v-if="this.$store.state.dataUsers.role == 'super_user'",
                  v-slot:selection="data"
                )
                  v-chip(v-if="edit == true", :input-value="id.selected") {{ id.item.bu_name }}
                  v-chip(v-else, :input-value="id.selected") {{ id.item.business_unit.bu_name }} {{ id.item.position }}
                template(
                  v-if="this.$store.state.dataUsers.role == 'super_user'",
                  v-slot:item="id"
                )
                  template(v-if="typeof id !== 'object'")
                    v-list-tile-content {{ id.item.business_unit }}
                  template(v-else)
                    v-list-tile-content
                      v-list-tile-title.mr-1(v-if="edit == true") {{ id.item.bu_name }}
                      v-list-tile-title.mr-1(v-else) {{ id.item.business_unit.bu_name }} {{ id.item.position }}

              v-autocomplete.mt-2(
                v-if="this.$store.state.dataUsers.role != 'super_user' && status < 2",
                label="Select a business unit",
                id="imSelectBU",
                v-model="bu",
                :items="business_units",
                no-data-text="No data available",
                chips,
                :item-text="data => `${data.bu_name ? data.bu_name : data.business_unit.bu_name} ${data.position ? 'as ' + data.position : ''}`",
                item-value="data",
                clearable,
                return-object
                @change="setBisnisUnit()"
              )
                template(
                  v-if="this.$store.state.dataUsers.role != 'super_user'",
                  v-slot:selection="data"
                )
                  v-chip(
                    v-if="edit == true && business_units.length > 1",
                    :input-value="data.selected"
                    v-bind="data.attrs"
                  ) {{ data.item.bu_name }} {{ data.item.position ? 'as ' + data.item.position : '' }}
                  v-chip(
                    v-else-if="edit == true && business_units.length == 1",
                    :input-value="data.selected"
                    v-bind="data.attrs"
                  ) {{ data.item.bu_name }}
                  v-chip(
                    v-else-if="edit == false && bu != null && business_units.length == 1",
                    :input-value="data.selected"
                    v-bind="data.attrs"
                  ) {{ data.item.business_unit.bu_name }}
                  v-chip(v-else, :input-value="data" v-bind="data.attrs") {{ data.item.business_unit.bu_name }} {{ data.item.position ? 'as ' + data.item.position : '' }}
                template(
                  v-if="this.$store.state.dataUsers.role != 'super_user'",
                  v-slot:item="data"
                )
                  template(v-if="typeof data !== 'object'")
                    v-list-tile-content {{ data.item.business_unit }}
                  template(v-else)
                    v-list-tile-content
                      v-list-tile-title.mr-1(
                        v-if="edit == true && business_units.length > 1"
                      ) {{ data.item.bu_name }} {{ data.item.position ? 'as ' + data.item.position : '' }}
                      v-list-tile-title.mr-1(
                        v-else-if="edit == true && business_units.length == 1"
                      ) {{ data.item.bu_name }}
                      v-list-tile-title.mr-1(
                        v-else-if="edit == false && bu != null && business_units.length == 1"
                      ) {{ data.item.business_unit.bu_name }}
                      v-list-tile-title.mr-1(v-else) {{ data.item.business_unit.bu_name }} {{ data.item.position ? 'as ' + data.item.position : '' }}

              v-autocomplete.mt-2(
                v-if="this.$store.state.dataUsers.role != 'super_user' && status > 2",
                label="Select a business unit",
                id="imSelectBU",
                v-model="bu",
                :items="business_units",
                no-data-text="No data available",
                chips,
                :disabled="edit == true && dataUsers.id !== dataEditRequest.imUser.id ? true : false",
                :item-text="data => `${data.bu_name ? data.bu_name : data.business_unit.bu_name} ${data.position ? 'as ' + data.position : ''}`",
                item-value="data",
                return-object
                clearable,
                @change="setBisnisUnit()"
              )
                template(
                  v-if="this.$store.state.dataUsers.role != 'super_user'",
                  v-slot:selection="data"
                )
                  v-chip(
                    v-if="edit == true && business_units.length > 1",
                    :input-value="data.selected"
                    v-bind="data.attrs"
                  ) {{ data.item.bu_name }} {{ data.item.position ? 'as ' + data.item.position : '' }}
                  v-chip(
                    v-else-if="edit == true && business_units.length == 1",
                    :input-value="data.selected"
                    v-bind="data.attrs"
                  ) {{ data.item.bu_name }}
                  v-chip(
                    v-else-if="edit == false && bu != null && business_units.length == 1",
                    :input-value="data.selected"
                    v-bind="data.attrs"
                  ) {{ data.item.business_unit.bu_name }}
                  v-chip(v-else, :input-value="data" v-bind="data.attrs") {{ data.item.business_unit.bu_name }} {{ data.item.position ? 'as ' + data.item.position : '' }}
                template(
                  v-if="this.$store.state.dataUsers.role != 'super_user'",
                  v-slot:item="data"
                )
                  template(v-if="typeof data !== 'object'")
                    v-list-tile-content {{ data.item.business_unit }}
                  template(v-else)
                    v-list-tile-content
                      v-list-tile-title.mr-1(
                        v-if="edit == true && business_units.length > 1"
                      ) {{ data.item.bu_name }} {{ data.item.position ? 'as ' + data.item.position : '' }}
                      v-list-tile-title.mr-1(
                        v-else-if="edit == true && business_units.length == 1"
                      ) {{ data.item.bu_name }}
                      v-list-tile-title.mr-1(
                        v-else-if="edit == false && bu != null && business_units.length == 1"
                      ) {{ data.item.business_unit.bu_name }}
                      v-list-tile-title.mr-1(v-else) {{ data.item.business_unit.bu_name }} {{ data.item.position ? 'as ' + data.item.position : '' }}

              v-autocomplete.mt-2(
                v-if="this.$store.state.dataUsers.role != 'super_user' && status > 1 && ![3,5].includes(status)",
                label="Select a business unit",
                id="imSelectBU",
                v-model="bu",
                :items="business_units",
                :disabled="edit == true && dataUsers.id !== dataEditRequest.imUser.id ? true : false",
                no-data-text="No data available",
                chips,
                :item-text="data => `${data.bu_name ? data.bu_name : data.business_unit.bu_name} ${data.position ? 'as ' + data.position : ''}`",
                item-value="data",
                return-object
                clearable,
                @change="setBisnisUnit()"
              )
                template(
                  v-if="this.$store.state.dataUsers.role != 'super_user'",
                  v-slot:selection="data"
                )
                  v-chip(
                    v-if="edit == true && business_units.length > 1",
                    :input-value="data.selected"
                    v-bind="data.attrs"
                  ) {{ data.item.bu_name }} {{ data.item.position ? 'as ' + data.item.position : '' }}
                  v-chip(
                    v-else-if="edit == true && business_units.length == 1",
                    :input-value="data.selected"
                    v-bind="data.attrs"
                  ) {{ data.item.bu_name }}
                  v-chip(
                    v-else-if="edit == false && bu != null && business_units.length == 1",
                    :input-value="data.selected"
                    v-bind="data.attrs"
                  ) {{ data.item.business_unit.bu_name }}
                  v-chip(v-else, :input-value="data" v-bind="data.attrs") {{ data.item.business_unit.bu_name }} {{ data.item.position ? 'as ' + data.item.position : '' }}
                template(
                  v-if="this.$store.state.dataUsers.role != 'super_user'",
                  v-slot:item="data"
                )
                  template(v-if="typeof data !== 'object'")
                    v-list-tile-content {{ data.item.business_unit }}
                  template(v-else)
                    v-list-tile-content
                      v-list-tile-title.mr-1(
                        v-if="edit == true && business_units.length > 1"
                      ) {{ data.item.bu_name }} {{ data.item.position ? 'as ' + data.item.position : '' }}
                      v-list-tile-title.mr-1(
                        v-else-if="edit == true && business_units.length == 1"
                      ) {{ data.item.bu_name }}
                      v-list-tile-title.mr-1(
                        v-else-if="edit == false && bu != null && business_units.length == 1"
                      ) {{ data.item.business_unit.bu_name }}
                      v-list-tile-title.mr-1(v-else) {{ data.item.business_unit.bu_name }} {{ data.item.position ? 'as ' + data.item.position : '' }}

          v-row.mt-6 
            v-col(cols="2")
              v-subheader.mt-3(color="black")
                span.red--text *
                span(style="font-size: 16px; font-weight: 600") Category
            v-col(cols="9")
              v-autocomplete.mt-2(
                id="imSelectCat",
                label="Select a category",
                v-model="category",
                :items="categoryMemo",
                no-data-text="No data available",
                chips,
                item-text="text",
                item-value="value",
                clearable,
              )
                template(v-slot:selection="{ attrs, item, select, selected }")
                  v-chip(
                    :model-value="selected"
                  ) {{ item.text }}

          v-row.mt-6
            v-col(cols="2") 
              v-subheader.mt-3(color="black")
                span.red--text *
                span(style="font-size: 16px; font-weight: 600") Subject
            v-col(cols="9")
              v-text-field(id="imSubject", v-model.trim="perihal" label="Write a subject")

          v-row.mt-6
            v-col(cols="2") 
              v-subheader(color="black")
                span.red--text *
                span(style="font-size: 16px; font-weight: 600") Purpose
            v-col(cols="9")
              <textarea id="editor1" name="editor1"></textarea>

          v-row.mt-6
            v-col(cols="2") 
              v-subheader(color="black")
                span.red--text *
                span(style="font-size: 16px; font-weight: 600") Background
            v-col(cols="9")
              <textarea id="editor2" name="editor2"></textarea>

          v-row.mt-6
            v-col(cols="2") 
              v-subheader(color="black")
                span.red--text *
                span(style="font-size: 16px; font-weight: 600") Propose
            v-col(cols="9")
              <textarea id="editor3" name="editor3"></textarea>
          v-row.mt-2.mb-4
            v-col(cols="2") 
              v-subheader(color="black")
                span(style="font-size: 16px; font-weight: 600") Attachment File
            v-col(cols="9")
              v-flex(xs12, sm6, md12, mb-2)
                div.mt-1(style="font-size: 14px") 
                  input#file(
                    v-if="fileName.length > 0",
                    type="file",
                    ref="fileadd",
                    style="display: none",
                    v-on:change="addFile()",
                    accept=".7z, .rar, .pdf, .doc, .docx, .zip, .xlsx, .xls, image/*",
                    multiple
                  )
                  v-btn(
                    v-if="fileName.length > 0",
                    outlined,
                    color="primary",
                    @click="$refs.fileadd.click()"
                  ) 
                    v-icon add
                    | Add file
                  input#file(
                    v-if="fileName.length == 0",
                    type="file",
                    ref="file",
                    style="display: none",
                    v-on:change="uploadLampiran()",
                    accept=".7z, .rar, .pdf, .doc, .docx, .zip, .xlsx, .xls, image/*",
                    multiple
                  )
                  v-btn(
                    v-if="fileName.length == 0",
                    outlined,
                    color="primary",
                    @click="$refs.file.click()"
                  ) 
                    v-icon add
                    | Add file
                  p.mt-1 Max Size: 5 MB. Allowed: .pdf, .doc, .zip, .7zip, .rar,  .docx, .xlsx, .xls, or images
                  v-alert.mt-2(
                    v-model="uploadAlert",
                    color="red",
                    dense,
                    text,
                    dismissible
                  ) The file is too big. Max file size 5 MB
                  v-spacer.mt-2
                  //- b(style="font-size:14px; font-weight: 600;") total files: {{fileName.length}}
                  v-row.mt-1
                    v-chip.ma-2(
                      v-if="fileName.length > 0",
                      v-for="(item, index) in fileName",
                      :key="item",
                      close
                      @click:close="removeLampiran(item, index)" 
                    )
                      span(v-if="item.name != null") {{ item.name | truncate(15, '...') }}
                      span(v-else) {{ item | truncate(15, '...') }}

      v-layout.mt-8
        v-btn(
          id="imPage1Cancel"
          depressed,
          v-if="$store.state.dataUsers.role == 'super_user'",
          large,
          @click="$router.push('/my-request')"
        ) CANCEL
        v-btn(id="imPage1Cancel", depressed, v-else, large, @click="$router.push('/')") CANCEL
        v-btn.ml-3(
          id="imPage1Next"
          color="blue-secondary",
          depressed,
          large,
          @click="nextHandle",
          :disabled = "isDelayForWsywig || !bu || !category || !perihal || bu.length == 0"
        ) NEXT

    v-stepper-content(step="2")
      v-alert(
        dismissible,
        color="red",
        dark,
        v-model="alert",
        transition="scale-transition"
      ) {{ alertMessage }}
      v-layout(row, wrap)
        v-flex(xs6, sm6, v-show="showApprover")
          //p.headline.my-1 Requestor :

          //p.headline.my-1 Approver :
          v-autocomplete.ml-4.mt-2(
            label="Approver",
            v-model="approver",
            id="imInternalApprover"
            :items="nonBodUsers",
            no-data-text="No data available",
            chips,
            color="blue-grey lighten-2",
            :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
            item-value="data",
            return-object,
            multiple,
            :append-icon="'close'"
            @click:append="handleClearEvent(1)"
            :readonly="max_total_approver !== 0 ? approver.length >= max_total_approver : false"
          )
            template(v-slot:selection="data")
              v-chip(
                v-bind="data.attrs"
                :input-value="data.selected"
                close,
                @click:close="removeApp(data.item)"
              ) {{ data.item.alias }}
            template(v-slot:item="data")
              template(v-if="typeof data !== 'object'")
                v-list-tile-content(v-text="data.item")
              template(v-else)
                v-list-tile-content
                  v-list-tile-title.mr-1 {{ data.item.alias }} - {{ data.item.position }} ({{ data.item.business_unit.bu_name }})
                  p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}
                  //- v-list-tile-sub-title(v-html="data.item.email")


          //- ========== APPROVER CROSS BU DATA BARU ===========
          v-autocomplete(
            :search-input.sync='search' 
            v-model="approver"
            :items="crosBu"
            chips
            color="blue-grey lighten-2"
            label="Approver Cross BU"
            id="imCrossApprover"
            :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
            item-value="data"
            multiple
            :loading='isLoading'
            :append-icon="'close'"
            @click:append="handleClearEvent(2)"
            hide-no-data='' 
            hint="Enter at least 3 letters to find out the search results."
            return-object=true
            :readonly="max_total_approver !== 0 ? approver.length >= max_total_approver : false"
            ).ml-4.mt-2
            template(v-slot:selection="data")
              v-chip(
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="removeApp(data.item)"
              ) {{data.item.alias}}

            template(v-slot:item="data")
              template(v-if="typeof data.item !== 'object'")
                v-list-tile-content(v-text="data.item")
              template(v-else)
                v-list-tile-content
                  v-list-tile-title.mr-1 {{data.item.alias}} - {{data.item.position}} ({{ data.item.business_unit.bu_name }})
                  p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}

          v-autocomplete.ml-4(
            label="CC",
            v-model="tembusan",
            :items="getCCData",
            id="imInternalCC"
            no-data-text="No data available",
            chips,
            color="blue-grey lighten-2",
            :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
            item-value="data",
            return-object,
            multiple,
            :append-icon="'close'"
            @click:append="handleClearEvent(3)"
            @change="removeCc()"
            hide-details
          )
            template(v-slot:selection="data")
              v-chip.chip--select-multi(
                :selected="data.selected",
                close,
                @click:close="removeCc(data.item)"
              ) {{ data.item.alias }}
            template(v-slot:item="data")
              template(v-if="typeof data !== 'object'")
                v-list-tile-content(v-text="data.item")
              template(v-else)
                v-list-tile-content
                  v-list-tile-title.mr-1 {{data.item.alias}} - {{data.item.position}} ({{ data.item.business_unit.bu_name }})
                  p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}
                  //- v-list-tile-sub-title(v-html="data.item.title")
          
          small(style="color: #F08703;" class="ml-4") *CC can only view memo, cannot approve memo.

          v-autocomplete(
            :search-input.sync='searchCC' 
            v-model="tembusan"
            id="imCrossCC"
            :items="getCrosCCData"
            chips
            color="blue-grey lighten-2"
            label="Cross CC"
            :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
            item-value="data"
            multiple
            :loading='isLoading'
            :append-icon="'close'"
            @click:append="handleClearEvent(4)"
            hide-no-data='' 
            hint="Enter at least 3 letters to find out the search results."
            return-object=true
            @change="removeCc()"
          ).ml-4.mt-2
            template(v-slot:selection="data")
              v-chip(
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click:close="removeCc(data.item)"
              ) {{data.item.alias}}

            template(v-slot:item="data")
              template(v-if="typeof data.item !== 'object'")
                v-list-tile-content(v-text="data.item")
              template(v-else)
                v-list-tile-content
                  v-list-tile-title.mr-1 {{data.item.alias}} - {{data.item.position}} ({{ data.item.business_unit.bu_name }})
                  p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}

          v-flex.autocomplete-result.d-flex.flex-row.align-center.ml-5
            v-checkbox.mr-2(
              id="imCBHideTTL",
              v-model="disabledHidetitle",
              label="Hide Title",
              :disabled="useAlias"
            )
            v-checkbox(id="imCBUseAls", v-model="useAlias" label="Use Alias Name")
            v-checkbox(id="imCBShowLogo", style='margin-left:1rem' v-model="useLogo" label="Show Company Logo")
          
          p(style="color: #F08703; font-size: 12px" class="ml-4" v-if="use_setting_max_approver && max_total_approver !== 0") *Each memo may have a maximum of ({{max_total_approver}}) approvers assigned within your Business Unit. Kindly ensure that the approver list does not exceed this limit.

        v-flex(xs6, sm6, pl-3)
          .badge-approval.d-flex(
            v-if="dataEditRequest.imStatus == 1 || $route.name == 'Memo'"
          ) 
            .mr-3
              img(src="../assets/icon/ic_tips.svg")
            .align-self-center
              i Tips: Drag and drop the approver by holding down the left mouse and dragging them. (Approval sequence follow when user input the approver)

          template
            .mb-5.mt-5
              p.title.mb-1 Approver
              ol.autocomplete-results(v-show="approver")
                draggable.list-group(
                  :list="approver",
                  :disabled="!enabled",
                  ghost-class="ghost",
                  @start="dragging = true",
                  @end="dragging = false"
                )
                  li.autocomplete-result(
                    v-for="(requestor, i) in approver",
                    key="i"
                  )
                    v-chip.list-group-item.ma-1(v-if="dataEditRequest.imStatus != 3 && showApprover", @click:close="removeApp(requestor)",x-large,close,label) 
                      div
                        p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                        p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                        p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Approver is not active
                    v-chip.ma-1(v-else, label x-large) 
                      div
                        p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                        p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                        p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Approver is not active
          template
            .mb-5.mt-5
              p.title.mb-1 CC
              ol.autocomplete-results(v-show="tembusan")
                li.autocomplete-result(
                  v-for="(requestor, i) in tembusan",
                  key="i"
                )
                  v-chip.list-group-item.ma-1(v-if="dataEditRequest.imStatus != 3 && showApprover", @click:close="removeCc(requestor)",x-large,close,label) 
                    div
                      p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                      p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                      p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Account is not active
                  v-chip.ma-1(v-else, label, x-large) 
                    div
                      p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                      p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                      p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Account is not active
                  //- v-chip.ma-1(
                  //-   v-if="showApprover",
                  //-   @click:close="removeCc(requestor)",
                  //-   close,
                  //-   label
                  //- ) {{ requestor.alias }} {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                  //- v-chip.ma-1(v-else, label) {{ requestor.alias }} {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}

      v-btn.mr-2(
        id="imPage2Cancel"
        depressed,
        v-if="$store.state.dataUsers.role == 'super_user'",
        large,
        @click="$router.push('/my-request')"
      ) CANCEL
      v-btn.mr-2(id="imPage2Cancel", depressed, v-else, large, @click="$router.push('/')") CANCEL

      v-btn(id="imPage2Back" dark, color="blue-grey", depressed, large, @click="currentStep--") BACK
      //IMView(:dialogType="dialogType" :cuisItems="imPreview" :userDetail="dataUsers")

      //- WithdrawDialog.mr-2(
      //-   v-if="dataEditRequest.imStatus == 3 && $route.name == 'Edit Memo' && dataUsers._id == dataEditRequest.imUser._id",
      //-   :imId="dataEditRequest._id",
      //-   :type="dataEditRequest.imType",
      //-   creator
      //- )

      v-btn.ml-2(
        v-if="status < 2 && this.showApprover",
        id="imPage2btnDraft"
        color="info",
        depressed,
        large,
        :disabled="isPage2Complete",
        @click="submitForm(1)"
      )
        v-icon insert_drive_file
        | &nbsp; Save as Draft
      v-btn.ml-2(
        id="imPage2btnSubmit"
        depressed,
        large,
        color="success",
        @click="submitForm(2)",
        :disabled="isPage2Complete"
      )
        v-icon send
        | &nbsp; Submit Request

  v-overlay(:value="isLoading")
    v-progress-circular(indeterminate, size="64")
</template>

<script>
import * as i18n from "../data/i18n.json";
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import IMView from "@/components/IMView.vue";
import { Money } from "v-money";
// import { constants } from 'crypto';
import { MyCustomUploadAdapterPlugin } from "../utils/MyUploadAdapter";
import WithdrawDialog from "@/components/WithdrawWizard.vue";
import draggable from "vuedraggable";

export default {
  name: "WizardNonBudget",
  components: {
    IMView,
    Money,
    draggable,
    WithdrawDialog,
  },
  props: {
    edit: { type: Boolean, default: false },
  },
  data() {
    return {
      isDelayForWsywig: true,
      useLogo: true,
      errorActiveUserMsg: "",
      dialogInactiveApprover: false,
      listCC: [],
      enabled: this.$route.fullPath.includes("create-memo") ? true : false,
      dragging: false,
      addExternalDialog: false,
      rules: {
        required: (value) => !!value || "This field is required",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid email format";
        },
        msisdn: (value) =>
          (value && value.length >= 10) ||
          "Mobile number cannot be less than 10",
      },
      data_memo: null,
      data_lampiran: [],
      alert: false,
      i18n: i18n.default,
      // currentStep: this.edit ? 6 : 0,
      currentStep: 1,
      stepperHeaders: i18n.headerWizard,
      perihal: null,
      prioritas: null,
      //- editorTujuan: myEditor1.getData(),
      //- editorLatarBelakang: myEditor2.getData(),
      //- editorUsulan: myEditor3.getData(),
      editorTujuan: "",
      editorLatarBelakang: "",
      editorUsulan: "",
      approver: [],
      approverList: [],
      status: 0,
      organization: null,
      currItems: ["IDR", "USD"],
      currency: "IDR",
      nilai: 0,
      dari: "",
      kepada: "",
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      },
      nilaiFormat: null,
      group: "bcg",
      targetDate: new Date().toISOString().substr(0, 10),
      pickerStyle: false,
      tujuan: null,
      file: [],
      deleteFile: [],
      fileName: [],
      workflow: [],
      notif: {},
      dialogType: "form",
      imType: null,
      imVendor: null,
      vendorLain: null,
      vendors: [],
      vendorHint: null,
      show: "display:none;",
      showAlasan: "display:none;",
      showOtherTextField: "display:none;",
      showOtherCheckbox: "display:none;",
      showHistory: "display:none;",
      showBudget: "display:;",
      showNonBudget: "display:none;",
      showNoDocument: "display:none;",
      noDocument: "",
      isLoading: false,
      otherVendor: false,
      alasan: null,
      historyDlg: false,
      historyIm: [],
      historyHeaders: [
        {
          text: "IM Number",
          value: "imNo",
        },
        {
          text: "IM Status",
          value: "imStatus",
        },
        {
          text: "Preview",
        },
      ],
      weUsers: [],
      pemohonHint: [],
      showPemohon: "display:none;",
      isLoadingPemohon: false,
      pemohon3: null,
      pemohon3Hint: [],
      showPemohon3: "display:none;",
      isLoadingPemohon3: false,
      pemohon4: null,
      pemohon4Hint: [],
      showPemohon4: "display:none;",
      isLoadingPemohon4: false,
      approver1: null,
      approver1Hint: [],
      showApprover1: "display:none;",
      isLoadingApprover1: false,
      approver2: null,
      approver2Hint: [],
      showApprover2: "display:none;",
      isLoadingApprover2: false,
      budgetControl: null,
      isLoadingBudgetControl: false,
      budgetControlHint: "",
      showBudgetControl: "display:none;",
      budget: [],
      users: [],
      nonBodUsers: [],
      pemohon: [],
      bod: [],
      bods: [],
      bu: [],
      business_units: [],
      autoUpdate: true,
      isUpdating: false,
      requestors: [],
      isOpen: false,
      search: null,
      searchCC: null,
      tembusan: null,
      cc: null,
      submitClick: false,
      useAlias: true,
      hideTitle: [],
      disabledHidetitle: false,
      ngCompany: "",
      alertMessage: "",
      uploadAlert: false,
      extraApproval: {},
      showApprover: true,
      isCreator: null,
      crosBu: [],
      statusEdit: null,
      clearFile: false,
      bu_id: null,
      categoryMemo: i18n.category,
      category: null,
      max_total_approver: 0,
      use_setting_max_approver: true,
    };
  },
  mounted: async function () {
    setTimeout(() => {
      this.isDelayForWsywig = false;
      const allCC = this.$store.state.dataEditRequest.imCC;
      let resultEditXCC = [];
      for (let i in allCC) if (allCC[i].isCros) this.listCC.push(allCC[i]);
    }, 4000);

    // this.organization = this.dataUsers.organization[0];
    this.imType = this.i18n.imType[this.dataEditRequest.imType];
    if (this.imType !== this.i18n.imType[3]) {
      this.showBudget = "display:block;";
    }
    //if (this.edit) {
    if (this.imType == this.i18n.imType[3]) {
      this.show = "display:block;";
      this.showOtherCheckbox = "display:block;";
      this.showAlasan = "display:block;";
      this.otherVendor = false;
      this.vendorLain = "";
    }
    //}
    //- let vendor = await this.getAllVendor();
    //- for (const item of vendor) {
    //-   this.vendors.push(item.name);
    //- }

    await this.getUsers();
    this.setUseAlias();
  },

  computed: {
    ...mapState(["API_URL", "dataUsers", "dataEditRequest"]),
    getCrosCCData() {
      let result = [];
      for (let i in this.listCC) {
        this.listCC[i].isCros = true;
        result.push(this.listCC[i]);
      }
      return result;
    },
    getCCData() {
      let result = [];
      for (let i in this.nonBodUsers) {
        this.nonBodUsers[i].isCros = false;
        result.push(this.nonBodUsers[i]);
      }
      return result;
    },
    isPage1Complete() {
      if (this.bu == null) {
        return (this.bu = null);
      }
      if (this.bu.business_unit != null) {
        this.getApproval(this.bu.business_unit);
        this.getAllBu(this.bu.business_unit.id);
        this.bu_id = this.bu.business_unit.id;
        return (
          !!this.bu.id &&
          !!this.category &&
          !!this.perihal &&
          !!myEditor1.getData().trim() &&
          myEditor1.getData().trim() != "<p>&nbsp;</p>" &&
          !!myEditor2.getData().trim() &&
          myEditor2.getData().trim() != "<p>&nbsp;</p>" &&
          !!myEditor3.getData().trim() &&
          myEditor3.getData().trim() != "<p>&nbsp;</p>"
        );
      } else {
        this.getApproval(this.bu);
        if (this.bu.id != undefined) {
          this.getAllBu(this.bu.id);
          this.bu_id = this.bu.id;
        }
        return (
          !!this.bu.id &&
          !!this.category &&
          !!this.perihal &&
          !!myEditor1.getData().trim() &&
          myEditor1.getData().trim() != "<p>&nbsp;</p>" &&
          !!myEditor2.getData().trim() &&
          myEditor2.getData().trim() != "<p>&nbsp;</p>" &&
          !!myEditor3.getData().trim() &&
          myEditor3.getData().trim() != "<p>&nbsp;</p>"
        );
      }

      //- return (
      //-   this.bu &&
      //-   this.perihal &&
      //-   this.editorTujuan &&
      //-   this.editorLatarBelakang &&
      //-   this.editorUsulan
      //- )
    },
    isPage2Complete: function () {
      if (this.approver === null) return false;
      if (this.approver) {
        // if (
        //   this.use_setting_max_approver &&
        //   this.approver.length > this.max_total_approver
        // )
        //   return true;
        return this.approver.length > 0 ? false : true;
      }
    },

    formIsValid() {
      return (
        this.extraApproval.name &&
        this.extraApproval.email &&
        this.extraApproval.msisdn &&
        this.extraApproval.msisdn.length >= 10 &&
        this.extraApproval.msisdn.length <= 16
      );
    },
  },

  methods: {
    handleClearEvent(al) {
      let data1 = [];
      let data2 = [];
      let result = [];
      if (al == 1) {
        data1 = this.approver;
        data2 = this.nonBodUsers;
      } else if (al == 2) {
        data1 = this.approver;
        data2 = this.crosBu;
      } else if (al == 3) {
        data1 = this.tembusan;
        data2 = this.getCCData;
      } else if (al == 4) {
        data1 = this.tembusan;
        data2 = this.getCrosCCData;
      }

      for (let i in data1) {
        let isFound = false;
        for (let j in data2) {
          if (data1[i].id == data2[j].id) isFound = true;
        }
        if (!isFound) result.push(data1[i]);
      }

      if (al == 1 || al == 2) this.approver = result;
      else this.tembusan = result;
    },
    nextHandle: function () {
      if (myEditor1.getData().trim().length == 0) return;
      if (myEditor2.getData().trim().length == 0) return;
      if (myEditor3.getData().trim().length == 0) return;
      if (this.isPage1Complete) this.currentStep++;
    },
    onEditorReady: function () {
      if (this.edit) {
        this.editorTujuan = " " + this.dataEditRequest.imTujuan;
        this.editorLatarBelakang = " " + this.dataEditRequest.imLatarBelakang;
        this.editorUsulan = " " + this.dataEditRequest.imUsulan;
      }
    },

    setBisnisUnit() {
      let token = localStorage.getItem("token");
      axios
        .get(
          process.env.VUE_APP_API +
            `/business-unit/detail/${
              this.edit == true ? this.bu.id : this.bu.business_unit.id
            }`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          let dataBU = res.data;

          dataBU.id = dataBU._id;
          delete dataBU._id;

          this.organization = dataBU;

          this.approver = [];
          this.listCC = [];
          this.tembusan = null;
          if (this.use_setting_max_approver) {
            this.max_total_approver = dataBU.max_approver
              ? dataBU.max_approver
              : 0;
          }
        })
        .catch((err) => {
          this.$toasted.error(err, { icon: "error" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    requestorClear() {
      this.pemohon = [];
      if (this.dataUsers.organization[0].approver.length > 0) {
        this.pemohon.push(this.dataUsers.organization[0].approver[0]);
      }
    },
    removeReq(item) {
      let requestors = this.pemohon.indexOf(item);
      if (this.edit) {
        for (const key in this.pemohon) {
          if (this.pemohon[key].id == item.id) {
            requestors = key;
            break;
          }
        }
      }
      if (requestors >= 0) this.pemohon.splice(requestors, 1);
    },

    removeApp(item) {
      // const index = this.users.indexOf(item)
      // if (index >= 0) this.users.splice(index, 1)

      let approvers = this.approver.indexOf(item);
      if (this.edit) {
        for (const key in this.approver) {
          if (this.approver[key].id == item.id) {
            approvers = key;
            break;
          }
        }
      }
      if (approvers >= 0) this.approver.splice(approvers, 1);
      this.removecrBu(item);
    },
    removeBudget(item) {
      // const index = this.users.indexOf(item)
      // if (index >= 0) this.users.splice(index, 1)
      let budgets = this.budget.indexOf(item);
      if (this.edit) {
        for (const key in this.budget) {
          if (this.budget[key].id == item.id) {
            budgets = key;
            break;
          }
        }
      }
      if (budgets >= 0) this.budget.splice(budgets, 1);
    },
    removeBod(item) {
      // const index = this.bods.indexOf(item)
      // if (index >= 0) this.bods.splice(index, 1)
      let bodData = this.bod.indexOf(item);
      if (this.edit) {
        for (const key in this.bod) {
          if (this.bod[key].id == item.id) {
            bodData = key;
            break;
          }
        }
      }
      if (bodData >= 0) this.bod.splice(bodData, 1);
    },
    removeCc(item) {
      // const index = this.users.indexOf(item)
      // if (index >= 0) this.users.splice(index, 1)
      let tembusans = this.tembusan.indexOf(item);
      if (this.edit) {
        for (const key in this.tembusan) {
          if (this.tembusan[key].id == item.id) {
            tembusans = key;
            break;
          }
        }
      }
      if (tembusans >= 0) this.tembusan.splice(tembusans, 1);
    },

    getApproval(data) {
      if (this.edit) {
        if (data.id != this.dataEditRequest.imOrganization.id) {
          if (this.approver.length == 0) {
            this.approver = [];
          }
        }
        //- if(data.id==this.dataEditRequest.imOrganization.id){
        //-   this.approver = this.dataEditRequest.imWorkflow
        //- }
      }

      if (data.id != null) {
        let token = localStorage.getItem("token");
        //axios.get(process.env.VUE_APP_API+`/users/active/bu/${this.$store.state.dataUsers.user._id}`
        axios
          .get(process.env.VUE_APP_API + `/users/bu/list/${data.id}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            this.nonBodUsers = res.data.data;
          })
          .catch((err) => {
            this.$toasted.error(err);
          });
      }
    },
    getAllBu(bu_id) {
      //- =========== UNTUK DATA BARU ==========
      let token = localStorage.getItem("token");
      this.crosBu = [];
      axios
        .get(process.env.VUE_APP_API + `/users/busines-unit/${bu_id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          res.data.data.forEach((item) => {
            if (
              item.is_active &&
              item.name != this.$store.state.dataUsers.user.full_name
            ) {
              this.approver.forEach((data) => {
                if (item.email == data.email) {
                  this.crosBu.push(data);
                }
              });
            }
          });
        })
        .catch((err) => {
          this.$toasted.error(err);
        });

      //- ============ UNTUK DATA LAMA ===========
      //- let token = localStorage.getItem("token");
      //- this.crosBu = [];
      //- axios
      //-   .get(process.env.VUE_APP_API + `/users/busines-unit/${bu_id}`, {
      //-     headers: { Authorization: `Bearer ${token}` },
      //-   })
      //-   .then((res) => {
      //-     res.data.data.forEach((item) => {
      //-       if (item.is_active) {
      //-         if (item.name != this.$store.state.dataUsers.user.full_name) {
      //-           this.crosBu.push(item);
      //-         }
      //-       }
      //-     });
      //-   })
      //-   .catch((err) => {
      //-     this.$toasted.error(err);
      //-   });
    },
    getUsers: async function () {
      let token = localStorage.getItem("token");
      axios
        .get(process.env.VUE_APP_API + `/users/info`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          this.dataUsers = res.data.data.user;

          if (res.data.data.role == "super_user") {
            let token = localStorage.getItem("token");
            axios
              .get(process.env.VUE_APP_API + `/business-unit/list`, {
                headers: { Authorization: `Bearer ${token}` },
              })
              .then((res) => {
                res.data.data.forEach((data) => {
                  this.business_units.push(data);
                });
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => (this.loading = false));
          } else {
            if (this.edit) {
              axios
                .get(
                  process.env.VUE_APP_API +
                    `/users/active/bu/${this.$store.state.dataUsers.user._id}`,
                  {
                    headers: { Authorization: `Bearer ${token}` },
                  }
                )
                .then((res) => {
                  let isFlg = true;
                  res.data.data.forEach((data) => {
                    if (res.data.data.length > 0 && isFlg) {
                      if (
                        this.dataEditRequest.imOrganization.id ==
                          data.business_unit.id &&
                        this.dataEditRequest.imStatus != 1
                      ) {
                        this.bu = {
                          id: data.business_unit.id,
                          bu_name: data.business_unit.bu_name,
                          position:
                            this.dataEditRequest.imStatus == 1
                              ? this.dataEditRequest.imUser.position
                              : null,
                          userId: data.id,
                        };
                        this.business_units.push({
                          id: data.business_unit.id,
                          bu_name: data.business_unit.bu_name,
                          position:
                            this.dataEditRequest.imStatus == 1
                              ? this.dataEditRequest.imUser.position
                              : null,
                          userId: data.id,
                        });
                      } else if (
                        this.dataEditRequest.imOrganization.id !=
                          data.business_unit.id &&
                        this.dataEditRequest.imStatus != 1
                      ) {
                        this.bu = {
                          id: this.dataEditRequest.imOrganization.id,
                          bu_name: this.dataEditRequest.imOrganization.name,
                        };

                        this.business_units.push({
                          id: this.dataEditRequest.imOrganization.id,
                          bu_name: this.dataEditRequest.imOrganization.name,
                        });
                      } else {
                        if (this.dataEditRequest.imUser.id == data.id) {
                          this.bu = {
                            id: data.business_unit.id,
                            bu_name: data.business_unit.bu_name,
                            position: data.position,
                            userId: data.id,
                          };
                        }

                        this.business_units.push({
                          id: data.business_unit.id,
                          bu_name: data.business_unit.bu_name,
                          position:
                            this.dataEditRequest.imStatus == 1
                              ? data.position
                              : null,
                          userId: data.id,
                        });
                      }
                    } else if (isFlg) {
                      if (
                        this.dataEditRequest.imOrganization.id !=
                        data.business_unit.id
                      ) {
                        this.bu = {
                          id: this.dataEditRequest.imOrganization.id,
                          bu_name: this.dataEditRequest.imOrganization.name,
                          userId: data.id,
                        };

                        this.business_units.push({
                          id: this.dataEditRequest.imOrganization.id,
                          bu_name: this.dataEditRequest.imOrganization.name,
                          userId: data.id,
                        });
                      } else {
                        this.bu = {
                          id: data.business_unit.id,
                          bu_name: data.business_unit.bu_name,
                          userId: data.id,
                        };

                        this.business_units.push({
                          id: data.business_unit.id,
                          bu_name: data.business_unit.bu_name,
                          userId: data.id,
                        });
                      }
                    }

                    if (
                      this.dataEditRequest.imOrganization.id ==
                        data.business_unit.id &&
                      this.dataEditRequest.imStatus == 3 &&
                      data.id == this.dataEditRequest.imUser.id
                    ) {
                      this.bu = {
                        id: this.dataEditRequest.imUser.business_unit.id,
                        bu_name:
                          this.dataEditRequest.imUser.business_unit.bu_name,
                        position: this.dataEditRequest.imUser.position,
                        userId: this.dataEditRequest.imUser.id,
                      };
                      this.business_units.push({
                        id: this.dataEditRequest.imUser.business_unit.id,
                        bu_name:
                          this.dataEditRequest.imUser.business_unit.bu_name,
                        position: this.dataEditRequest.imUser.position,
                        userId: this.dataEditRequest.imUser.id,
                      });
                      isFlg = false;
                    }
                  });

                  const token = localStorage.getItem("token");
                  axios
                    .get(
                      `${process.env.VUE_APP_API}/business-unit/detail/${this.bu.id}`,
                      { headers: { Authorization: `Bearer ${token}` } }
                    )
                    .then((res) => {
                      //- alert(JSON.stringify(res.data))
                      if (!res.data.is_active) this.bu = "";
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                });

              //- for (const item of this.$store.state.dataUsers.user.bu) {
              //-     //- this.business_units.push(item.business_unit)
              //- }
            } else {
              axios
                .get(
                  process.env.VUE_APP_API +
                    `/users/active/bu/${this.$store.state.dataUsers.user._id}`,
                  {
                    headers: { Authorization: `Bearer ${token}` },
                  }
                )
                .then((res) => {
                  res.data.data.forEach((data) => {
                    this.business_units.push(data);
                  });
                  if (res.data.data.length == 1 && this.edit == false) {
                    this.bu = res.data.data[0];
                    this.setBisnisUnit();
                  }
                })
                .catch((err) => {
                  console.log(err);
                })
                .finally(() => (this.loading = false));
            }
          }
        })
        .catch((err) => {
          if (err.response.status == 401 || err.response.status == 403) {
            return this.$router.push("/logout");
          }
        })
        .finally(() => (this.loading = false));

      if (this.edit == true) {
        return this.business_units;
      }
    },

    addExtraApproval: async function () {
      this.extraApproval.alias = this.extraApproval.name;
      this.nonBodUsers.push(this.extraApproval);
      this.approver.push(this.extraApproval);
      this.addExternalDialog = false;
      this.extraApproval = {};
    },

    onCurrencyChange() {
      if (this.currency === "IDR") {
        this.money = {
          decimal: ",",
          thousands: ".",
          prefix: "",
          suffix: "",
          precision: 0,
          masked: false,
        };
      } else {
        this.money = {
          decimal: ".",
          thousands: ",",
          prefix: "",
          suffix: "",
          precision: 0,
          masked: false,
        };
      }
    },
    onImTypeChange() {
      this.show = "display:none;";
      this.showAlasan = "display:none;";
      this.showOtherTextField = "display:none;";
      this.showOtherCheckbox = "display:none;";
      this.showHistory = "display:none;";
      this.showBudget = "display:;";
      this.showNonBudget = "display:none;";
      this.showNoDocument = "display:none;";
      if (this.imType === this.i18n.imType[1]) {
        this.showNoDocument = "display:;";
      }
      if (this.imType === this.i18n.imType[2]) {
        this.showNoDocument = "display:;";
      }
      if (this.imType === this.i18n.imType[3]) {
        this.show = "display:block;";
        this.showAlasan = "display:block;";
        this.showOtherCheckbox = "display:block;";
        this.onVendorChange();
        this.otherVendor = false;
        this.vendorLain = "";
        this.showBudget = "display:none;";
      }
      if (this.imType === this.i18n.imType[5]) {
        this.showBudget = "display:none;";
        this.showNonBudget = "display:;";
      }

      this.approverList = [];
      let typeIndex = 0;
      for (const key in this.approver) {
        if (this.approver.hasOwnProperty(key)) {
          switch (this.imType) {
            case this.i18n.imType[1]:
              typeIndex = 1;
              break;
            case this.i18n.imType[2]:
              typeIndex = 2;
              break;
            case this.i18n.imType[3]:
              typeIndex = 3;
              break;
            case this.i18n.imType[4]:
              typeIndex = 4;
              break;
            case this.i18n.imType[5]:
              typeIndex = 5;
              break;
          }

          if (this.approver[key].imType.includes(typeIndex)) {
            this.approverList.push(parseInt(key));
          }
        }
      }
    },
    filterResults() {
      this.results = this.items.filter(
        (item) => item.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      );
    },
    onVendorChange: async function () {
      this.showHistory = "display:none;";
      if (this.imVendor != null) {
        const vendor = await this.getVendorByName(this.imVendor);
        this.vendorHint =
          vendor.appointed > 0
            ? `<span style="color:#ff2c03;">WARNING. Vendor ini sudah pernah ditunjuk langsung : ${vendor.appointed} kali</span>`
            : null;
        this.showHistory =
          vendor.appointed > 0 ? "display:block;" : "display:none;";
        this.historyIm = await this.getImByVendor(this.imVendor);
      }
    },
    onOtherVendor: function () {
      this.show = "display:block;";
      this.showOtherTextField = "display:none;";
      if (this.imType === this.i18n.imType[3] && this.otherVendor) {
        this.showOtherTextField = "display:block;";
        this.show = "display:none;";
        this.showHistory = "display:none;";
        this.imVendor = null;
      }
    },
    getAllVendor: async function () {
      let group = this.group == "bcg" ? "BC" : "GEMS";
      const config = {
        method: "get",
        url: `${this.API_URL}/api/vendors?group=${group}`,
        headers: { Authorization: `Bearer ${this.$store.state.token}` },
      };
      const vendors = await axios(config);
      return vendors.data;
    },
    getVendorByName: async function (vendorName) {
      const config = {
        method: "get",
        url: `${this.API_URL}/api/vendor/by-name?name=${vendorName}`,
        headers: { Authorization: `Bearer ${this.$store.state.token}` },
      };
      const vendor = await axios(config);
      return vendor.data[0];
    },
    getImByVendor: async function (vendorName) {
      const config = {
        method: "get",
        url: `${this.API_URL}/api/requests/by/vendor?name=${vendorName}`,
        headers: { Authorization: `Bearer ${this.$store.state.token}` },
      };
      const vendor = await axios(config);
      return vendor.data;
    },
    getImTypeId: function (tipe) {
      if (tipe === this.i18n.imType[1]) return 1;
      if (tipe === this.i18n.imType[2]) return 2;
      if (tipe === this.i18n.imType[3]) return 3;
      if (tipe === this.i18n.imType[4]) return 4;
      if (tipe === this.i18n.imType[5]) return 5;
      if (tipe === this.i18n.imType[11]) return 11;
    },
    getNonBodUsers: async function () {
      const config = {
        method: "get",
        url: `${this.API_URL}/api/bod`,
        headers: { Authorization: `Bearer ${this.$store.state.token}` },
      };
      const bod = await axios(config);
      return bod;
    },
    getBod: async function () {
      const config = {
        method: "get",
        url: `${this.API_URL}/api/bod`,
        headers: { Authorization: `Bearer ${this.$store.state.token}` },
      };
      const bod = await axios(config);
      return bod;
    },
    addFile: function () {
      //this.$refs.fileadd.click();
      for (const key in this.$refs.fileadd.files) {
        if (this.$refs.fileadd.files[key].size != undefined) {
          if (this.$refs.fileadd.files[key].size <= 5242880) {
            // 5 MB

            let check = this.file.filter(
              (data) => data.name == this.$refs.fileadd.files[key].name
            );
            if (check.length == 0) {
              this.file.push(this.$refs.fileadd.files[key]);
              this.fileName.push(this.$refs.fileadd.files[key].name);
            }
            this.uploadAlert = false;
          } else {
            //- empty upload file
            this.uploadAlert = true;
            document.getElementById("file").value = "";
          }
        }
      }
    },
    uploadLampiran() {
      if (this.edit) {
        if (this.file.length < 0) {
          this.fileName = [];
        }
      }
      this.file = [];

      for (const key in this.$refs.file.files) {
        if (this.$refs.file.files[key].size != undefined) {
          if (this.$refs.file.files[key].size <= 5242880) {
            // 5 MB

            let check = this.file.filter(
              (data) => data.name == this.$refs.file.files[key].name
            );
            if (check.length == 0) {
              this.file.push(this.$refs.file.files[key]);
              this.fileName.push(this.$refs.file.files[key].name);
            }

            //- this.file[key] = this.$refs.file.files[key];
            //- this.fileName[key] = this.$refs.file.files[key].name;
            this.uploadAlert = false;
          } else {
            //- empty upload file
            this.uploadAlert = true;
            document.getElementById("file").value = "";
          }
        }
      }
    },
    removeLampiran(name, index) {
      if (this.edit) {
        if (
          this.fileName[index].url == name.url &&
          this.fileName[index].url != undefined
        ) {
          this.fileName.splice(this.fileName.indexOf(name), 1);
        } else {
          this.file.splice(index, 1);
          for (var i = 0; i < this.fileName.length; i++) {
            if (this.fileName[i] === name) {
              this.fileName.splice(i, 1);
            }
          }
        }
      } else {
        this.fileName.splice(this.fileName.indexOf(name), 1);
        this.file.splice(index, 1);
      }

      this.$refs.fileadd.value = "";
      if (this.fileName.length == 0 && this.file.length == 0) {
        this.clearFile = true;
        this.dataEditRequest.imFileLampiran = [];
      }

      this.dataEditRequest.imFileLampiran = [];
      this.fileName.forEach((item) => {
        if (item.url != null) {
          this.dataEditRequest.imFileLampiran.push(item);
        }
      });
    },
    getUTC7Date(tgl) {
      let tanggal = new Date(tgl);
      let month =
        tanggal.getMonth() + 1 < 10
          ? "0" + (tanggal.getMonth() + 1)
          : tanggal.getMonth() + 1;
      let date =
        tanggal.getDate() < 10 ? "0" + tanggal.getDate() : tanggal.getDate();
      return tanggal.getFullYear() + "-" + month + "-" + date;
    },
    printPreview: function () {
      printJS({
        printable: {},
        type: "json",
        properties: ["key", "value"],
        gridHeaderStyle: "display:none;",
      });
    },
    check: function () {
      var cek = false;
      var item = 0;
      for (const index in this.approverList) {
        if (this.approverList.hasOwnProperty(index)) {
          if (this.approver[this.approverList[index]].id === "BOD1") {
            item = parseInt(this.approverList[index]);
            this.approverList.splice(index, 1);
            cek = true;
          }
        }
      }
      if (cek) this.approverList.push(item);
    },

    UploadAttachtment: async function (data) {
      let formData = new FormData();
      formData.append("attachment", data);
      const config = {
        method: "post",
        url: process.env.VUE_APP_API + `/memo/upload-file`,
        headers: {
          Authorization: `Bearer ${this.$store.state.token}`,
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      };
      await axios(config)
        .then((res) => {
          //this.data_memo.attachment.push(res.data.data)
          this.data_lampiran.push(res.data.data);
          //this.data_memo.attachment = res.data.data
        })
        .catch((err) => {
          let err_msg = err.response.data.message;
          this.$toasted.error(err_msg, { icon: "error" });
        });
    },

    submitForm: async function (status) {
      const statusBeforeSubmit = this.status;
      this.submitClick = true;
      this.isLoading = true;
      let isNeedReview = this.status == 3 ? true : false;
      let isReSubmited = 0;
      this.status = status;

      const requestors = [];
      for (const [i, item] of this.pemohon.entries()) {
        if (typeof item.status === "undefined") {
          this.$set(item, "status", 6);
        }
        if (typeof item.comment === "undefined") {
          this.$set(item, "comment", null);
        }
        if (typeof item.leadtime === "undefined") {
          this.$set(item, "leadtime", null);
        }
        if (typeof item.postAs === "undefined") {
          this.$set(item, "postAs", "requestor");
        }
        if (typeof item.userType === "undefined") {
          this.$set(item, "userType", 2);
        }
        requestors.push(item);
      }

      const approvers = [];
      const data_approvers = {};

      if (this.tembusan) {
        for (const item of this.tembusan) {
          if (!item.is_active) {
            this.errorActiveUserMsg =
              statusBeforeSubmit == 3
                ? "Sorry, there is inactive account. Please contact admin or withdraw memo."
                : "Sorry, there is inactive account. Please close or change new account.";
            this.dialogInactiveApprover = true;
            this.isLoading = false;
            this.status = statusBeforeSubmit;
            return;
          }
        }
      }

      for (const item of this.approver) {
        if (!item.is_active) {
          this.errorActiveUserMsg =
            statusBeforeSubmit == 3
              ? "Sorry, there is inactive account. Please contact admin or withdraw memo."
              : "Sorry, there is inactive account. Please close or change new account.";
          this.dialogInactiveApprover = true;
          this.isLoading = false;
          this.status = statusBeforeSubmit;
          return;
        }
        //- if (typeof item.status === "undefined") {
        //-   this.$set(item, "status", 6);
        //- }
        if (typeof item.comment === "undefined") {
          this.$set(item, "comment", null);
        }

        if (this.useAlias) {
          this.$set(item, "name", item.name);
        }

        this.$set(item, "postAs", "approver");

        approvers.push(item);
      }

      if (this.edit && this.status > 1) {
        var imWf = [];
        var newApp = [];
        var statusBefore = 7;
        imWf.push(...requestors, ...approvers);
        for (const item of imWf) {
          if (
            (item.status == 9 || item.status == 3) &&
            this.dataEditRequest.imUser.id != this.dataUsers.user._id
          ) {
            item.status = 7;
            item.comment = "";
            item.date = new Date();
          }
          if (item.status == null && statusBefore == 7) item.status = 9;
          if (item.status == 6 && statusBefore == 7) item.status = 9;
          statusBefore = item.status;
          newApp.push(item);
        }

        if (this.tembusan != null) {
          var ccs = [];
          ccs.push(...this.tembusan);
        } else {
          ccs = this.tembusan;
        }

        if (isNeedReview && newApp[0].status == 9) {
          isReSubmited = 1;
        }

        if (this.status == 2 && newApp[0].status == null) {
          newApp[0].status = 9;
        }
      } else {
        newApp = requestors.concat(approvers);
        //-  newApp[0].status = 9;
        if (this.status == 2) newApp[0].status = 9;
        ccs = this.tembusan;
      }

      let imVendor = null;
      if (this.getImTypeId(this.imType) == 3) {
        if (this.otherVendor) {
          let nospace = this.vendorLain.replace(" ", "");
          let codeVendor = "IM".concat(nospace.substr(0, 4)).toUpperCase();
          imVendor = JSON.stringify({
            code: codeVendor,
            name: this.vendorLain,
            appointed: 0,
          });
        } else {
          imVendor = JSON.stringify(await this.getVendorByName(this.imVendor));
        }
      }

      //- if (this.edit) {
      //-   this.bu.id = this.dataEditRequest.imUser.id;
      //- }
      const get_data_creator = {
        method: "get",
        url:
          process.env.VUE_APP_API +
          `/memo/creator/${this.edit ? this.bu.userId : this.bu.id}`,
        headers: {
          Authorization: `Bearer ${this.$store.state.token}`,
        },
      };

      let creator_da = await axios(get_data_creator).then((res) => {
        this.isCreator = res.data.data;
        return res.data.data;
      });

      //- if (this.edit) {
      //-   this.bu.id = this.dataEditRequest.imUser.business_unit.id;
      //- }

      let formData = new FormData();
      if (this.edit) {
        let isRoleCreator = false;
        for (let dataUserBU of this.$store.state.dataUsers.user.bu) {
          if (dataUserBU.id == this.dataEditRequest.imUser.id) {
            isRoleCreator = true;
          }
        }

        if (!isRoleCreator) {
          formData.append("isApproverEdit", 1);
        } else {
          formData.append("isApproverEdit", 0);
          formData.append("userId", this.$store.state.dataUsers.user._id);
        }

        formData.append("_id", this.dataEditRequest._id);
        formData.append("imNo", this.dataEditRequest.imNo);
        if (this.dataEditRequest.imStatus == 1) {
          let tempDataImUser = creator_da;
          tempDataImUser.label = creator_da.business_unit.bu_name;
          tempDataImUser.value = creator_da.business_unit.id;
          formData.append("imUser", JSON.stringify(tempDataImUser));
        } else
          formData.append(
            "imUser",
            JSON.stringify(this.dataEditRequest.imUser)
          );

        if (this.dataEditRequest.imStatus == 3) {
          formData.append("isNeedReview", 1);
        } else {
          formData.append("isNeedReview", 0);
        }
        //- this.isLoading = false;
        //- return
      }

      creator_da != null
        ? (creator_da.name = this.$store.state.dataUsers.user.full_name)
        : null;
      if (creator_da != null) {
        formData.append("userId", this.$store.state.dataUsers.user._id);
      }
      if (creator_da != null) {
        formData.append("user", JSON.stringify(creator_da));
      }

      formData.append("imCategory", this.category);
      formData.append("imPerihal", this.perihal.replaceAll(`"`, `'`));
      formData.append("imNoDocument", this.noDocument);
      //- formData.append("imPrioritas", this.prioritas);
      formData.append("imType", 5);
      formData.append("imUseLogo", this.useLogo ? true : false);
      formData.append("status", this.statusEdit);
      formData.append(
        "imTujuan",
        myEditor1
          .getData()
          .replace(/<meta charset="utf-8">/g, "")
          .replace(/dir="ltr"/g, "")
      );
      formData.append(
        "imLatarBelakang",
        myEditor2
          .getData()
          .replace(/<meta charset="utf-8">/g, "")
          .replace(/dir="ltr"/g, "")
      );
      formData.append(
        "imUsulan",
        myEditor3
          .getData()
          .replace(/<meta charset="utf-8">/g, "")
          .replace(/dir="ltr"/g, "")
      );
      formData.append("imStatus", this.status);
      //- formData.append("imOrganization", JSON.stringify(this.organization));
      //-
      if (this.dataEditRequest.imStatus == 3 && this.edit) {
        formData.append(
          "person",
          JSON.stringify(
            this.dataEditRequest.imReturn[
              this.dataEditRequest.imReturn.length - 1
            ]
          )
        );
        formData.append(
          "imOrganization",
          JSON.stringify(this.dataEditRequest.imOrganization)
        );
      } else if (this.dataEditRequest.imStatus == 1 && this.edit) {
        //- alert('EIF')
        let chosenBUDetail = await axios.get(
          `${process.env.VUE_APP_API}/business-unit/detail/${this.bu.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.token}`,
            },
          }
        );
        chosenBUDetail.data.id = chosenBUDetail.data._id;
        delete chosenBUDetail.data._id;
        formData.append("imOrganization", JSON.stringify(chosenBUDetail.data));
        formData.append("draft", "draft");
      } else {
        //- alert('ELSE')
        formData.append("imOrganization", JSON.stringify(this.organization));
      }
      formData.append(
        "imValue",
        JSON.stringify({ currency: this.currency, value: parseInt(this.nilai) })
      );

      formData.append("imGroup", "nongroup");
      formData.append("imCompany", this.ngCompany);
      formData.append("imTargetDate", this.targetDate);
      if (this.edit) {
        formData.append("isReSubmited", isReSubmited);
      }
      formData.append("imUseAlias", this.useAlias ? true : false);
      formData.append("imHideTitle", this.disabledHidetitle ? true : false);

      formData.append("imRequestor", JSON.stringify(requestors));
      formData.append("imApprover", JSON.stringify(newApp));
      //- formData.append('imBOD', JSON.stringify(boddatas));

      if (Object.keys(ccs || {}).length == 0) {
        formData.append("imCC", null);
      } else {
        formData.append("imCC", JSON.stringify(ccs));
      }

      if (this.edit) {
        if (this.file.length > 0 && this.file[0].name) {
          for (const key in this.file) {
            await this.UploadAttachtment(this.file[key]);
          }

          this.data_memo = this.data_lampiran;

          if (this.dataEditRequest.imFileLampiran != null) {
            for (const key in this.data_memo) {
              this.dataEditRequest.imFileLampiran.push(this.data_memo[key]);
            }
          } else {
            this.dataEditRequest.imFileLampiran = this.data_memo;
          }

          formData.append(
            "imFileLampiran",
            JSON.stringify(this.dataEditRequest.imFileLampiran)
          );
          formData.append("imFilelength", this.file.length);
        } else {
          if (this.fileName.length > 0 && this.clearFile == false) {
            formData.append("imFileLampiran", JSON.stringify(this.fileName));
          } else {
            formData.append("imFileLampiran", null);
          }
        }
      } else {
        if (this.file.length > 0) {
          for (const key in this.file) {
            await this.UploadAttachtment(this.file[key]);
          }
          this.data_memo = this.data_lampiran;
          formData.append("imFileLampiran", JSON.stringify(this.data_memo));
          formData.append("imFilelength", this.file.length);
        }
      }

      let config = null;
      if (this.edit) {
        //- IF MEMO STATUS IS DRAFT
        if (this.$store.state.dataEditRequest.imStatus == 1) {
          const creatorID = this.$store.state.dataEditRequest.imUser.id;
          const listLoginUserBU = this.$store.state.dataUsers.user.bu;
          //- VALIDATE LOGIN USER HAVE SAME ID AS CREATOR MEMO
          for (let i in listLoginUserBU)
            if (listLoginUserBU[i].id == creatorID)
              formData.append("imDate", new Date().toISOString());
        }

        config = {
          method: "put",
          url:
            process.env.VUE_APP_API_OLD +
            `/api/requests/${this.dataEditRequest.imNo}/${this.$store.state.dataUsers.user._id}`,
          headers: { "Content-Type": "multipart/form-data" },
          data: formData,
        };
      } else {
        config = {
          method: "post",
          url: process.env.VUE_APP_API_OLD + `/api/requests`,
          headers: { "Content-Type": "multipart/form-data" },
          data: formData,
        };
      }

      axios(config)
        .then((res) => {
          if (res.status == 200) {
            this.isLoading = false;
            this.status == 1
              ? this.$toasted.info(
                  "Memo has been successfully saved to draft",
                  {
                    icon: "save",
                  }
                )
              : this.$toasted.success(
                  "Success, the memo was successfully generated and sent to the approver.",
                  {
                    icon: "check_circle",
                  }
                );
            this.$router.push("/my-request");
          }

          //- this.$store.commit("temporaryData", res);
          //- if (
          //-   this.edit &&
          //-   this.dataEditRequest.imUser.username == this.dataUsers.username &&
          //-   this.dataEditRequest.imStatus == 3
          //- )
          //-   this.$router.push("/my-request");
          //- else if (
          //-   this.dataUsers.userType == 2 &&
          //-   this.edit &&
          //-   this.dataEditRequest.imStatus != 1
          //- )
          //-   this.$router.push("/im-request/spv");
          //- else if (
          //-   this.dataUsers.userType == 4 &&
          //-   this.edit &&
          //-   this.dataEditRequest.imStatus != 1
          //- )
          //-   this.$router.push("/im-request/bod");
          //- else this.$router.push("/my-request");
          //- location.reload();
        })
        .catch((err) => {
          this.$toasted.error(err.response.data.message);
          this.isLoading = false;
          this.$router.push("/my-request");
          reject(err);
        });
    },

    isNumber(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[0-9]+$/.test(char)) return true;
      else e.preventDefault();
    },

    setUseAlias() {
      if (this.useAlias) {
        this.disabledHidetitle = true;
      }
    },
  },
  watch: {
    disabledHidetitle(val) {
      if (val != false || val != 0) {
        for (const key in this.bod) {
          this.hideTitle.push(this.bod[key].id);
        }
      } else {
        this.hideTitle = [];
      }
    },

    useAlias(val) {
      if (val != false || val != 0) {
        this.disabledHidetitle = true;
      } else if (this.disabledHidetitle == true && val == true) {
        this.disabledHidetitle = false;
        this.hideTitle = [];
      } else {
        this.hideTitle = [];
      }
    },

    pemohon() {
      if (this.pemohon.length > 0) {
        let requestor = this.pemohon[this.pemohon.length - 1];
        let isBreak = false;
        for (const item of this.budget) {
          if (requestor.id == item.id) {
            // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (Budget), silakan pilih salah satu!');
            this.alertMessage =
              "User Requestor yang Anda pilih sudah terpilih di kolom inputan Approver (Budget), silakan pilih salah satu!";
            isBreak = true;
            this.alert = true;
            this.pemohon.pop();
            break;
          }
        }
        for (const iterator of this.approver) {
          if (isBreak) break;
          if (requestor.id == iterator.id) {
            // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (beside BOD), silakan pilih salah satu!');
            this.alertMessage =
              "User Requestor yang Anda pilih sudah terpilih di kolom inputan Approver (beside BOD), silakan pilih salah satu!";
            isBreak = true;
            this.alert = true;
            this.pemohon.pop();
            break;
          }
        }
        //- for (const iterator of this.tembusan) {
        //-   if (isBreak) break;
        //-   if (requestor.id == iterator.id) {
        //-     // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (beside BOD), silakan pilih salah satu!');
        //-     this.alertMessage =
        //-       "User Requestor yang Anda pilih sudah terpilih di kolom inputan Tembusan, silakan pilih salah satu!";
        //-     isBreak = true;
        //-     this.alert = true;
        //-     this.pemohon.pop();
        //-     break;
        //-   }
        //- }
      } else {
        if (
          this.dataUsers.organization[0].approver.length > 0 &&
          this.pemohon.length == 0
        ) {
          this.pemohon.push(this.dataUsers.organization[0].approver[0]);
        }
      }
    },

    approver() {
      if (this.approver.length <= 0) {
        this.alert = false;
      }
      if (this.approver.length > 0) {
        let approver = this.approver[this.approver.length - 1];
        let isBreak = false;

        if (
          this.use_setting_max_approver &&
          this.max_total_approver !== 0 &&
          this.approver.length > this.max_total_approver
        ) {
          this.alertMessage =
            `It reaches the maximum number (${this.max_total_approver}) of approver allowed in your BU!`;
          this.alert = true;
          this.approver.pop();
        } else {
          for (const item of this.pemohon) {
            if (approver.id == item.id) {
              // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Requestor, silakan pilih salah satu!');
              this.alertMessage =
                "The user you selected has been selected in the previous input field, please choose one!";
              isBreak = true;
              this.alert = true;
              this.approver.pop();
              break;
            }
          }
          for (const iterator of this.budget) {
            if (isBreak) break;
            if (approver.id == iterator.id) {
              // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (Budget), silakan pilih salah satu!');
              this.alertMessage =
                "The user you selected has been selected in the previous input field, please choose one!";
              isBreak = true;
              this.alert = true;
              this.approver.pop();
              break;
            }
          }
          for (const iterator of this.tembusan) {
            if (isBreak) break;
            if (approver.id == iterator.id) {
              // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (Budget), silakan pilih salah satu!');
              this.alertMessage =
                "The user you selected has been selected in the previous input field, please choose one!";
              isBreak = true;
              this.alert = true;
              this.approver.pop();
              break;
            }
          }
        }
      }
    },
    tembusan() {
      if (this.tembusan.length > 0) {
        let tembusan = this.tembusan[this.tembusan.length - 1];
        let isBreak = false;
        for (const item of this.pemohon) {
          if (tembusan.id == item.id) {
            this.alertMessage =
              "The user you selected has been selected in the previous input field, please choose one!";
            isBreak = true;
            this.alert = true;
            this.tembusan.pop();
            break;
          }
        }
        for (const iterator of this.budget) {
          if (isBreak) break;
          if (tembusan.id == iterator.id) {
            // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (Budget), silakan pilih salah satu!');
            this.alertMessage =
              "The user you selected has been selected in the previous input field, please choose one!";
            isBreak = true;
            this.alert = true;
            this.tembusan.pop();
            break;
          }
        }
        for (const iterator of this.approver) {
          if (isBreak) break;
          if (tembusan.id == iterator.id) {
            // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (beside BOD), silakan pilih salah satu!');
            this.alertMessage =
              "The user you selected has been selected in the previous input field, please choose one!";
            isBreak = true;
            this.alert = true;
            this.tembusan.pop();
            break;
          }
        }
        for (const iterator of this.bod) {
          if (isBreak) break;
          if (tembusan.nik == iterator.id) {
            // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (beside BOD), silakan pilih salah satu!');
            this.alertMessage =
              "The user you selected has been selected in the previous input field, please choose one!";
            isBreak = true;
            this.alert = true;
            this.tembusan.pop();
            break;
          }
        }
      }
    },
    bod() {
      if (this.useAlias == true || this.useAlias == 1) {
        this.hideTitle.push(this.bod[this.bod.length - 1].id);
      }

      if (this.tembusan.length > 0) {
        let bod = this.bod[this.bod.length - 1];
        let isBreak = false;

        for (const iterator of this.tembusan) {
          if (isBreak) break;
          if (bod.id == iterator.nik) {
            // alert('User approver yang Anda pilih sudah terpilih di kolom inputan Approver (beside BOD), silakan pilih salah satu!');
            this.alertMessage =
              "User BOD yang Anda pilih sudah terpilih di kolom inputan Tembusan, silakan pilih salah satu!";
            isBreak = true;
            this.alert = true;
            this.bod.pop();
            break;
          }
        }
      }
    },

    isUpdating() {
      if (this.dataUsers.userType > 1 && this.edit) {
        this.isUpdating = true;
      }
    },
    dataEditRequest: async function () {
      if (this.dataEditRequest.imStatus == 5) {
        this.$toasted.error("Failed, memo has been withdrawn", {
          icon: "error",
        });
        setTimeout(() => this.$router.push({ path: "/my-approval" }), 2000);
      }

      this.category = this.dataEditRequest.hasOwnProperty("imCategory")
        ? this.dataEditRequest.imCategory
        : 1;
      this.perihal = this.dataEditRequest.imPerihal;
      this.statusEdit = this.dataEditRequest.status;
      setTimeout(() => {
        myEditor1.setData(this.dataEditRequest.imTujuan);
        myEditor2.setData(this.dataEditRequest.imLatarBelakang);
        myEditor3.setData(this.dataEditRequest.imUsulan);
        this.useLogo =
          this.$store.state.dataEditRequest.imUseLogo == "false" ? false : true;
      }, 2000);
      //- this.editorTujuan = "";
      //- this.editorLatarBelakang = "";
      //- this.editorUsulan = "";
      this.status = this.dataEditRequest.imStatus;
      //- this.file = this.dataEditRequest.imFileLampiran !== undefined ? this.dataEditRequest.imFileLampiran : null;
      this.organization = this.dataEditRequest.imOrganization;
      this.useAlias = this.dataEditRequest.imUseAlias == true ? true : false;
      this.disabledHidetitle =
        this.dataEditRequest.imHideTitle == true ? true : false;

      this.tembusan = [];
      //- this.bu = {
      //-   id:this.dataEditRequest.imOrganization.id,
      //-   bu_name:this.dataEditRequest.imOrganization.name
      //- }

      this.getAllBu(this.dataEditRequest.imOrganization.id);

      if (this.dataEditRequest.imStatus === 1) this.enabled = true;

      if (this.dataEditRequest.imCC != null) {
        for (const item of this.dataEditRequest.imCC) {
          this.tembusan.push(item);
        }
      }

      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${process.env.VUE_APP_API}/business-unit/detail/${this.dataEditRequest.imOrganization.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (
        new Date(this.dataEditRequest.imDate) >=
        new Date(process.env.CUT_OFF_MAX_APPROVER)
      ) {
        this.max_total_approver = res.data.max_approver ? res.data.max_approver : 0;
      } else {
        this.use_setting_max_approver = false;
      }

      if (
        this.dataEditRequest.imWorkflow.length > 0 &&
        this.dataEditRequest.imStatus != 1
      ) {
        this.dataEditRequest.imWorkflow.map((res) => {
          this.showApprover = false;
          this.approver.push(res);
          //- this.crosBu.push(res)
        });
      }

      if (
        this.dataEditRequest.imWorkflow.length > 0 &&
        this.dataEditRequest.imStatus == 1
      ) {
        this.dataEditRequest.imWorkflow.map((res) => {
          this.showApprover = true;
          this.approver.push(res);
          //- this.crosBu.push(res)
        });
      }

      if (this.dataEditRequest.imFileLampiran != "undefined") {
        for (const item of this.dataEditRequest.imFileLampiran) {
          this.fileName.push(item);
        }
      }
    },
    search(val) {
      if (val.length >= 3 && val.trim().length) {
        this.isLoading = true;
        let token = localStorage.getItem("token");
        axios
          .get(
            process.env.VUE_APP_API +
              `/users/busines-unit/${this.bu_id}?key=${val}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )
          .then(({ data }) => {
            const res = data.data;
            //- if (res.length != 0 ) this.crosBu = []
            for (let i in res)
              if (
                res[i].is_active &&
                res[i].name != this.$store.state.dataUsers.user.full_name
              )
                this.crosBu.push(res[i]);
          })
          .catch((err) => {
            if (err.response.status == 401 || err.response.status == 403) {
              this.$store.dispatch("logout");
              return this.$router.push("/");
            }
          })
          .finally(() => (this.isLoading = false));
      }
    },

    searchCC(val) {
      if (val.length >= 3 && val.trim().length) {
        this.isLoading = true;
        let token = localStorage.getItem("token");
        axios
          .get(
            process.env.VUE_APP_API +
              `/users/busines-unit/${this.bu_id}?key=${val}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )
          .then(({ data }) => {
            const res = data.data;
            //- if (res.length != 0 ) this.listCC = []
            for (let i in res)
              if (
                res[i].is_active &&
                res[i].name != this.$store.state.dataUsers.user.full_name
              )
                this.listCC.push(res[i]);
          })
          .catch((err) => {
            if (err.response.status == 401 || err.response.status == 403) {
              this.$store.dispatch("logout");
              return this.$router.push("/");
            }
          })
          .finally(() => (this.isLoading = false));
      }
    },
    imVendor() {
      if (this.imVendor == null) this.vendorHint = null;
    },
  },
  created() {
    let memoScript = document.createElement("script");
    memoScript.setAttribute("src", "/js/memo.js");
    document.body.appendChild(memoScript);

    setTimeout(async () => {
      if (this.edit) {
        let tempAlterData = this.$store.state.dataEditRequest;
        for (let x = 0; x < 10; x++) {
          if (!tempAlterData.imStatus) {
            await new Promise((resolve) => setTimeout(resolve, 1000));
            tempAlterData = this.$store.state.dataEditRequest;
          } else {
            break;
          }
        }
        if (tempAlterData.imStatus != 1 && tempAlterData.imStatus != 3) {
          this.$toasted.error("Failed, memo has been submiteda", {
            icon: "error",
          });
          this.$router.push("/my-request");
        }
        const searchUserBUID =
          tempAlterData.imReturn[tempAlterData.imReturn.length - 1].id;
        const searchUserBUs = this.$store.state.dataUsers.user.bu;
        let flag = false;
        for (let i in searchUserBUs)
          if (searchUserBUs[i].id == searchUserBUID) flag = true;
        if (tempAlterData.imStatus == 3 && !flag) {
          this.$toasted.error("Failed, memo has been submited", {
            icon: "error",
          });
          this.$router.push("/my-request");
        }

        //- DRAFT CONDITION ONLY THE CREATOR CAN OPEN THE PAGE
        if (
          tempAlterData.imStatus == 1 &&
          this.$store.state.dataUsers.user._id != tempAlterData.userId
        ) {
          this.$toasted.error("Failed, memo has been submited", {
            icon: "error",
          });
          this.$router.push("/my-request");
        }
      }
    }, 1000);
  },
};
</script>

<style>
.w-200 {
  width: 200px;
}
.w-full > div {
  width: 100% !important;
}
.ck {
  height: 200px;
}
.list-item {
  font-size: 16px;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.padTop10 {
  padding-top: 10px;
}
/* .v-select__selections{
  min-height: inherit !important;
  padding-top: 0 !important;
}
.v-input__slot{
  background: none !important;
  min-height: 0 !important;
} */

button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}

.badge-approval {
  background: #4caf501a;
  color: #4caf50;
  font-size: 12px;
  padding: 1rem;
  margin-top: 1.6rem;
}

.ck .ck-sticky-panel .ck-sticky-panel__content_sticky {
  position: static !important;
}

.v-autocomplete__content.v-menu__content {
  z-index: 4 !important;
}
</style>
